import {
    Editor,
    Element,
    Range,
    Transforms,
    type CodeInlineElement,
} from "slate";

/**
 * Gets the inline code element at the current selection, if any.
 */
export const getInlineCodeNode = (
    editor: Editor,
): CodeInlineElement | undefined => {
    const [match] = Editor.nodes<CodeInlineElement>(editor, {
        match: (n) =>
            !Editor.isEditor(n) &&
            Element.isElement(n) &&
            n.type === "code-inline",
    });

    if (match) {
        return match[0];
    }
};

/**
 * Unwraps the inline code element at the current selection, if there
 * is one. Any children of the element will be "raised" a level to be
 * children of their former grandparent element.
 */
export const unwrapInlineCodeNode = (editor: Editor) => {
    Transforms.unwrapNodes(editor, {
        match: (n) =>
            !Editor.isEditor(n) &&
            Element.isElement(n) &&
            n.type === "code-inline",
    });
};

/**
 * Wraps the current selection in an inline code element, if any text
 * is selected. If not (if the selection is collapsed), does nothing.
 */
export const wrapInlineCodeNode = (editor: Editor) => {
    const {selection} = editor;
    const isCollapsed = selection && Range.isCollapsed(selection);
    if (isCollapsed) {
        return;
    }

    if (getInlineCodeNode(editor)) {
        unwrapInlineCodeNode(editor);
    }

    Transforms.wrapNodes(
        editor,
        {type: "code-inline", children: []},
        {split: true},
    );
};
